import { Button } from '@mui/material';

interface TOCButtonProps {
  showToc?: boolean;
  onClick: () => void;
}

export default function TOCButton({ showToc, onClick }: TOCButtonProps) {
  return (
    <Button size='small' variant='text' className='toc-button' onClick={onClick}>
      {showToc ? <span>Hide TOC</span> : <span>Show TOC</span>}
    </Button>
  );
}
